




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGRowStringValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isText!: boolean;
  @Prop() private isEditable!: boolean;
  private textValue = '';

  constructor() {
    super();
    this.textValue = this.value;
  }

  getType() {
    if (this.isText) {
      return 'textarea';
    }
    return 'text';
  }

  saveChange(): void {
    this.$emit('valueChanged', this.textValue);
  }

  @Watch('value')
  refresh() {
    this.textValue = this.value;
  }
}
